import {Deserializable} from "./deserializable.model";

export class SystemLogTypeDataSector {

   log_type_data_sector_id: number;
   log_type_data_sector_name: string;
   log_type_data_sector_description: string;

    is_active: number;
    
    condition_array: any; // Actual Saved Model JSON of the data section action in angular
    condition_array_example: any; // Actual Example of Live event
    condition_array_fields: any; // A collection of all fields available // and valid for conditional validation in automations
    database_table_name: string; // The Real Mysql Database table name used
    database_table_fields_array: any; // array of all the database fields
    database_model_angular: any; // model code for angular
    created_tested: number;
    notes: string;

    log_type_data_sector_colour;
    log_type_data_sector_icon;

    condition_array_keys_example: any; // list of all the keys and dfinitions of implimentation of variables to place into ""
    database_mysql: any; // Insert model of the mysql at current state incase we have to reproduce the database
    condition_array_example_notes: any; // Notes about the example condition_array_example in proactice and implimentation.
    log_type_data_sector_type_id: any; // the ID of the data sector type.


  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): SystemLogTypeDataSector {
    Object.assign(this, input);

    return this;
  }


}
